import { plansFaqs } from "@/mocks/plansPage";

interface PlanFaqProps {
  open: string | null;
  onToggle: (q: string) => void;
}

/** Plan-specific FAQ accordion (billing, upgrades, expiry and custom options). */
export default function PlanFaq({ open, onToggle }: PlanFaqProps) {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-3">
      {plansFaqs.map((f) => {
        const expanded = open === f.q;
        return (
          <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <button
              type="button"
              aria-expanded={expanded}
              onClick={() => onToggle(f.q)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
            >
              <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{f.q}</span>
              <i
                className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform duration-200 ${
                  expanded ? "rotate-180" : ""
                }`}
              ></i>
            </button>
            {expanded && (
              <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                {f.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}